import React, { useState } from 'react'
import cross from '../../assets/produtcss/cross.svg'
import {
  FileUploadContainer,
  FileUploadLabel,
  FileNameText,
} from './style'

export interface ExistingAttachment {
  id: number
  originalName: string
  fileName: string
  filePath: string
  fileSize: number
  mimeType: string
}

interface AttachmentManagerProps {
  selectedFiles: File[]
  existingAttachments?: ExistingAttachment[]
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onRemoveFile: (index: number) => void
  onViewAttachment?: (attachment: ExistingAttachment) => void
  onDownloadAttachment?: (attachment: ExistingAttachment) => void
  onRemoveExistingAttachment?: (attachmentId: number) => void
  formatFileSize: (bytes: number) => string
  maxFileSize?: number
  accept?: string
  multiple?: boolean
}

const AttachmentManager: React.FC<AttachmentManagerProps> = ({
  selectedFiles,
  existingAttachments = [],
  onFileChange,
  onRemoveFile,
  onViewAttachment,
  onDownloadAttachment,
  onRemoveExistingAttachment,
  formatFileSize,
  maxFileSize = 200,
  accept = '*/*',
  multiple = true,
}) => {
  const [showOverlay, setShowOverlay] = useState(false)

  return (
    <>
      <div style={{ position: 'relative' }}>
        <FileUploadContainer>
          <FileUploadLabel
            htmlFor='file-upload-overlay'
            onClick={(e: React.MouseEvent) => {
              e.preventDefault()
              setShowOverlay(true)
            }}
          >
            Escolher arquivos
          </FileUploadLabel>
          <FileNameText>
            {selectedFiles.length > 0
              ? `${selectedFiles.length} novo(s) arquivo(s) selecionado(s)`
              : existingAttachments.length > 0
                ? `${existingAttachments.length} anexo(s) existente(s)`
                : 'Nenhum arquivo escolhido'}
          </FileNameText>
          <span
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              border: '1px solid #666',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              fontWeight: 'bold',
              fontStyle: 'italic',
              cursor: 'pointer',
              color: '#666',
            }}
            onClick={() => setShowOverlay(true)}
            title='Gerenciar anexos'
          >
            i
          </span>
        </FileUploadContainer>

        {showOverlay && (
          <>
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 9998,
              }}
              onClick={() => setShowOverlay(false)}
            />
            <div
              style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                padding: '24px',
                maxWidth: '600px',
                width: '90%',
                maxHeight: '80vh',
                overflowY: 'auto',
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                  Gerenciar Anexos
                </h3>
                <img
                  src={cross}
                  alt='Fechar'
                  onClick={() => setShowOverlay(false)}
                  style={{
                    cursor: 'pointer',
                    width: '16px',
                    height: '16px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <FileUploadContainer>
                  <FileUploadLabel htmlFor='file-upload'>
                    Escolher arquivos
                  </FileUploadLabel>
                  <input
                    id='file-upload'
                    type='file'
                    style={{ display: 'none' }}
                    onChange={onFileChange}
                    accept={accept}
                    multiple={multiple}
                  />
                  <FileNameText>
                    {selectedFiles.length > 0
                      ? `${selectedFiles.length} novo(s) arquivo(s) selecionado(s)`
                      : 'Nenhum arquivo escolhido'}
                  </FileNameText>
                </FileUploadContainer>
              </div>

              {selectedFiles.length > 0 && (
                <div
                  style={{
                    marginBottom: '20px',
                    padding: '12px',
                    backgroundColor: '#f9f9f9',
                    borderRadius: '4px',
                  }}
                >
                  <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
                    Novos arquivos:
                  </div>
                  <div
                    style={{
                      maxHeight: '150px',
                      overflowY: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                    }}
                  >
                    {selectedFiles.map((file, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '4px',
                          fontSize: '13px',
                        }}
                      >
                        <span style={{ flex: 1, wordBreak: 'break-word', marginRight: '8px' }}>
                          {file.name}
                        </span>
                        <span
                          onClick={() => onRemoveFile(index)}
                          style={{
                            cursor: 'pointer',
                            color: '#e74c3c',
                            fontWeight: 'bold',
                            flexShrink: 0,
                          }}
                          title='Remover'
                        >
                          ✕
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {existingAttachments.length > 0 && (
                <div
                  style={{
                    padding: '12px',
                    backgroundColor: '#e8f5e9',
                    borderRadius: '4px',
                  }}
                >
                  <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
                    Anexos existentes:
                  </div>
                  <div
                    style={{
                      maxHeight: '200px',
                      overflowY: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                    }}
                  >
                    {existingAttachments.map((attachment) => (
                      <div
                        key={attachment.id}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '4px',
                          fontSize: '13px',
                          minHeight: '36px',
                        }}
                      >
                        <span style={{ flex: 1, wordBreak: 'break-word', marginRight: '8px' }}>
                          {attachment.originalName} ({formatFileSize(attachment.fileSize)})
                        </span>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
                          {onViewAttachment && (
                            <span
                              onClick={() => onViewAttachment(attachment)}
                              style={{
                                cursor: 'pointer',
                                color: '#3498db',
                                fontSize: '18px',
                              }}
                              title='Visualizar'
                            >
                              👁️
                            </span>
                          )}
                          {onDownloadAttachment && (
                            <span
                              onClick={() => onDownloadAttachment(attachment)}
                              style={{
                                cursor: 'pointer',
                                color: '#27ae60',
                                fontSize: '18px',
                              }}
                              title='Download'
                            >
                              ⬇️
                            </span>
                          )}
                          {onRemoveExistingAttachment && (
                            <span
                              onClick={() => onRemoveExistingAttachment(attachment.id)}
                              style={{
                                cursor: 'pointer',
                                color: '#e74c3c',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              }}
                              title='Remover'
                            >
                              ✕
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default AttachmentManager
